import { useCurrentUser } from 'shared/hooks';

import { useUserProductMemberships } from './useUserProductMemberships';

/**
 * React hook to fetch the current user's memberships for the selected community.
 *
 * Uses React Query to asynchronously retrieve membership data from the marketplace API.
 * The query is enabled only if the current user is available.
 *
 * @returns The query result containing the membership data.
 * @throws {Error} If the current user is not available, or if the fetch fails.
 */
export function useCurrentUserProductMemberships() {
  const { user: currentUser } = useCurrentUser();

  return useUserProductMemberships(currentUser);
}
